import { STATIONS, NEW } from 'Features/routePaths';
import { StationType } from 'Services/api/v2/types';

export type StationProps = { station: StationType}

/** путь до станции: `/stations/${stationId}` */
export const getStationPath = (stationId: number | typeof NEW) => `/${STATIONS}/${stationId}`;
